import { FlexRowAlignCenter } from "@/components/Flex";
import { useAuthSlideContextSelector } from "../AuthSlide/hook/useAuthSlideContext";
import CircularOutlineIcon from "@/components/CircularButton/styled/CircularOutlineIcon";
import { X } from "lucide-react";
import br from "@/styles/breakpoints.module.css";
import KnowtLogo from "@/features/Sidebar/components/KnowtLogo";
import noop from "@knowt/syncing/utils/noop";

export const AuthKnowtLogo = ({
    containerStyle,
    onClose,
}: { containerStyle?: React.CSSProperties; onClose?: () => void }) => {
    const closeAuthSlide = useAuthSlideContextSelector(state => state.closeAuthSlide);

    return (
        <FlexRowAlignCenter style={{ ...containerStyle }} onClick={() => closeAuthSlide()}>
            <KnowtLogo onClick={noop} isExpanded={true} />

            {onClose && (
                <CircularOutlineIcon
                    className={br.mdUpDisplayNone}
                    onClick={onClose}
                    radius="4.7rem"
                    Icon={X}
                    size={30}
                    sx={{ marginLeft: "auto" }}
                />
            )}
        </FlexRowAlignCenter>
    );
};

export default AuthKnowtLogo;
